import { useSelector } from 'react-redux';
import { ReducerState } from '../../services/common/lib/reducerState';
import Logo from '../../components/Logo/Logo';
import SplashScreen from '../../features/auth/components/SplashScreen/SplashScreen';
import AvaturnCreator from './components/AvaturnCreator';
import { useEffect, useState } from 'react';
import useCreateAvaturnUser from '../../services/avaturn/queries/useCreateAvaturnUser';
import { IoIosArrowRoundBack } from 'react-icons/io';
import { useNavigate } from 'react-router-dom';
import ROUTES from '../../routers/Routes';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';

const Avaturn = () => {
  const user = useSelector((state: ReducerState) => state.auth);
  const [avaturnUserId, setAvaturnUserId] = useState<string | undefined>();
  const navigate = useNavigate();
  const { mutate, isPending, isError } = useCreateAvaturnUser();

  useEffect(() => {
    if (!user.avaturnUser) {
      mutate(user.id ? user.id : '', {
        onSuccess: ({ data }) => {
          setAvaturnUserId(data.id);
        },
      });
    }
  }, [user.avaturnUser, user.id]);

  const handleGoBack = () => {
    if (window.history?.state?.usr?.from) {
      navigate(window.history.state.usr.from, { replace: true });
    } else {
      navigate(ROUTES.LOBBY, { replace: true });
    }
  };
  return (
    <SplashScreen logoHeader={false}>
      <div className="h-5vh z-30 flex w-full select-none items-center justify-between p-2">
        <IoIosArrowRoundBack
          size={32}
          className="text-lg font-bold text-ph-gray-silver hover:cursor-pointer hover:text-ph-gray-jumbo"
          onClick={handleGoBack}
        />

        <Logo />

        <div />
      </div>

      {isPending && <LoadingSpinner size="12" />}

      {isError && (
        <div className="mt-1/2 flex h-dvh items-center justify-center">
          <p>Something went wrong, try again later</p>
        </div>
      )}

      {(user.avaturnUser?.id || avaturnUserId) && (
        <AvaturnCreator avaturnId={(user.avaturnUser?.id || avaturnUserId) as string} />
      )}
    </SplashScreen>
  );
};

export default Avaturn;
